import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import type { FilterConfig } from '@alltrails/denali/components/FilterBar';
import { Modal, ModalStep } from '@alltrails/modal';
import FiltersModalContent from '../../FiltersModalContent/FiltersModalContent';

type FiltersModalProps = Pick<ComponentProps<typeof Modal>, 'onCloseRequest'> & {
  filterConfigs: FilterConfig[];
  onClear?: () => void;
  onSeeTrailsClick?: () => void;
  trailResultCount: number | null; // null indicates loading
};

const FiltersModal = ({ onCloseRequest, filterConfigs, onClear, onSeeTrailsClick, trailResultCount }: FiltersModalProps) => {
  const onPrimaryClick = () => {
    onSeeTrailsClick?.();
    onCloseRequest();
  };
  return (
    <ModalStep
      buttons={{
        primaryButton: {
          loading: trailResultCount === null,
          onClick: onPrimaryClick,
          text: (
            <FormattedMessage defaultMessage="Show {count} {count, plural, one {trail} other {trails}}" values={{ count: trailResultCount ?? 0 }} />
          ),
          testId: 'show-trails'
        },
        ...(onClear
          ? {
              flatButton: {
                onClick: onClear,
                text: <FormattedMessage defaultMessage="Clear" />,
                testId: 'clear-filters'
              }
            }
          : {})
      }}
      onCloseRequest={onCloseRequest}
      title={<FormattedMessage defaultMessage="Filters" />}
    >
      <FiltersModalContent filterConfigs={filterConfigs} />
    </ModalStep>
  );
};

export default FiltersModal;
